export const TRACKCB_CONVERSION_API_HELPER_TEXT = 
  "When creating Pixel settings for the first time, Select Last 7 Days or Current. Once initial data is captured, either for Current or Last 7 days, this setting will change to Last Record Time. Last Record Time (within 7 days) will ensure all records are captured during any occurrence of downtime or delay.";

export const TRACKCB_CONVERSION_API_SYNC_TYPES = {
  LAST_SYNC: 1,
  SEVEN_DAYS: 2,
  CUSTOM: 3,
};
